export const GaiiaArch = {
  THEMIS: 'THEMIS',
  IRIS: 'IRIS',
  ALCYONE: 'ALCYONE',
  IBGE: 'IBGE',
  URANO: 'URANO'
};
